import * as React from 'react';

import usePermissions from 'hooks/usePermissions';
import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';

import StepActionButton from './StepActionButton';

type Props = {
  actionUrl: string;
  config: EventProcedureStepAPIType['action']['config'];
};

function StepPerformSearch({ config, actionUrl }: Props) {
  const { saved_search } = config;
  const { isPermitted } = usePermissions();
  const disabled = saved_search && !isPermitted(`view:read:${saved_search}`);

  return (
    <StepActionButton
      hint={disabled ? "You don't have access to see this saved search" : undefined}
      title="Perform Search"
      to={disabled ? null : actionUrl}
      disabled={disabled}
    />
  );
}

export default StepPerformSearch;
